/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_On_PortalInputs */

const cs_portals_on_portal = /** @type {(inputs: Portals_On_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na portálu`)
};

const en_portals_on_portal = /** @type {(inputs: Portals_On_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On portal`)
};

/**
* | output |
* | --- |
* | "On portal" |
*
* @param {Portals_On_PortalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_on_portal = /** @type {((inputs?: Portals_On_PortalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_On_PortalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_on_portal(inputs)
	return cs_portals_on_portal(inputs)
});